import Button from "@material-ui/core/Button";
import Divider from "@material-ui/core/Divider";
import Grid from "@material-ui/core/Grid";

import { makeStyles } from "@material-ui/core";

import _ from "lodash";

import { useUser } from "providers/UserProvider";

import { MapReadingData } from "types/Readings/Base";

import { removeUserNotification } from "features/firebase/userNotifications";
import { getDaysUntilNextNotification } from "utils/notifications";
import {
  getCurrentReadingsStreak,
  getMaximumReadingsStreak
} from "utils/waterReadingAnalytics";

import { usePhotos } from "providers/PhotosProvider";

const useStyles = makeStyles((theme) => ({
  button: {
    marginBottom: `${theme.spacing(2)}px`
  },
  divider: {
    margin: theme.spacing(1)
  },
  gridItem: {
    padding: theme.spacing(1),
    backgroundColor: theme.palette.grey[50],
    borderRadius: theme.spacing(1)
  },
  gridItemHighlight: {
    fontSize: "1.1rem",
    fontWeight: 700,
    color: theme.palette.primary.main
  }
}));

const ReminderSummary = () => {
  const classes = useStyles();

  const { user, setUser } = useUser();

  const photos = usePhotos();

  const userReadingPhotos =
    photos?.features?.geojson &&
    _.reverse(
      _.sortBy(
        photos?.features?.geojson.features.filter(
          (f) => (f.properties as MapReadingData).userId === user?.id
        ),
        ["properties.dateTime"]
      )
    );

  const waterNotification = user?.notifications?.find(
    (n) => n.title === "Water quality reading reminder"
  );

  let daysUntilNextTest = 0;
  let currentStreak = 0;
  let bestStreak = 0;
  if (waterNotification) {
    daysUntilNextTest = getDaysUntilNextNotification(waterNotification);
    currentStreak = getCurrentReadingsStreak(userReadingPhotos);
    bestStreak = getMaximumReadingsStreak(userReadingPhotos);
  }

  const handleCancelReminders = async () => {
    if (user) {
      const notifications = await removeUserNotification(
        user?.id,
        "Water quality reading reminder"
      );
      setUser({
        ...user,
        notifications: notifications
      });
    }
  };

  return (
    <>
      {waterNotification && (
        <>
          <Grid container spacing={2}>
            <Grid item xs={4}>
              <div className={classes.gridItem}>
                Current streak
                <br />
                <span className={classes.gridItemHighlight}>
                  {currentStreak}
                </span>
              </div>
            </Grid>
            <Grid item xs={4}>
              <div className={classes.gridItem}>
                Best streak
                <br />
                <span className={classes.gridItemHighlight}>{bestStreak}</span>
              </div>
            </Grid>
            <Grid item xs={4}>
              <div className={classes.gridItem}>
                Next test in
                <br />
                <span className={classes.gridItemHighlight}>
                  {`${daysUntilNextTest} days`}
                </span>
              </div>
            </Grid>
            <Grid item xs={12}></Grid>
          </Grid>
          <Button
            variant="outlined"
            color="primary"
            className={classes.button}
            fullWidth
            onClick={handleCancelReminders}
            disableElevation
          >
            Cancel test reminder
          </Button>
          <Divider className={classes.divider} />
        </>
      )}
    </>
  );
};

export default ReminderSummary;
